/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import platform from 'platform';
import ScriptVoiceModel from '@components/ScriptVoiceModel';
import Spinner from '@components/Spinner';

type IProps = {
  language: string;
  step: number;
  isPediatric: boolean;
};
const VoiceModelRightSideInternalTool = ({
  language,
  step,
  isPediatric,
}: IProps) => {
  const { t } = useTranslation(['modelRecording']);
  const [currentBrowser, setCurrentBrowser] = React.useState('');

  const MAX_STEPS = isPediatric
    ? Number(process.env.REACT_APP_FINAL_STEP_PEDIATRIC)
    : Number(process.env.REACT_APP_FINAL_STEP);

  React.useEffect(() => {
    if (platform.name) {
      setCurrentBrowser(platform?.name);
    }
  }, []);

  return !step ? (
    <Spinner />
  ) : (
    <>
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <div className={styles.script}>
            <div className={styles.innerContent}>
              <p className={styles.count}>
                {step}{' '}
                {t('modelRecording:script.of', {
                  total: MAX_STEPS - 1,
                })}
              </p>
              <div className={styles.script}>
                <ScriptVoiceModel
                  lang={language}
                  step={step}
                  isPediatric={isPediatric}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VoiceModelRightSideInternalTool;
